module.exports = __webpack_public_path__ + "img/洱海入口.ace61825.jpg";